export enum enumQuoteState {
    Invoiced = 1,
    Accepted = 2,
    Rejected = 3,
    Open = 4,
    NotSent = 5
};